import React from 'react'
import { motion, useInView } from 'framer-motion'
import { getPageData, useData } from '../../app/helper/functions'
import BannerAppComponent from '../molecules/BannerAppComponent/BannerAppComponent'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import ChooseUs from '../molecules/ChooseUs/ChooseUs'
import ReliabilityAndroidSteps from '../molecules/ReliabilityAndroidSteps/ReliabilityAndroidSteps'
import AndroidIdeaProject from '../molecules/AndroidIdeaProject/AndroidIdeaProject'
import AndroidFeatures from '../molecules/AndroidFeatures/AndroidFeatures'
import AndroidConceptBox from '../molecules/AndroidConceptBox/AndroidConceptBox'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'

const AndroidPage = () => {
    const { data } = useData();
    const androidData = getPageData(data, 'androidPage');

    // Animation variants
    const fadeIn = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { duration: 0.8 } }
    }

    const slideUp = {
        hidden: { y: 20, opacity: 0.6 },
        visible: { y: 0, opacity: 1, transition: { duration: 0.8, ease: "easeOut" } }
    }

    const staggerContainer = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    }

    // Create refs for each section
    const reliabilityRef = React.useRef(null);
    const ideaProjectRef = React.useRef(null);
    const featuresRef = React.useRef(null);
    const conceptBoxRef = React.useRef(null);
    const projectDisplayRef = React.useRef(null);
    const faqRef = React.useRef(null);
    const chooseUsRef = React.useRef(null);

    // Use useInView hook for each section
    const reliabilityInView = useInView(reliabilityRef, { once: false, amount: 0.3 });
    const ideaProjectInView = useInView(ideaProjectRef, { once: false, amount: 0.1 });
    const featuresInView = useInView(featuresRef, { once: false, amount: 0.3 });
    const conceptBoxInView = useInView(conceptBoxRef, { once: false, amount: 0.3 });
    const projectDisplayInView = useInView(projectDisplayRef, { once: false, amount: 0.3 });
    const faqInView = useInView(faqRef, { once: false, amount: 0.3 });
    const chooseUsInView = useInView(chooseUsRef, { once: false, amount: 0.3 });

    return (
        <motion.div
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
            className="w-full overflow-x-hidden"
        >
            <motion.div variants={fadeIn} className="w-full ">
                <BannerAppComponent
                    bgImage='bg-android-bg'
                    title={androidData.title}
                    description={androidData.description} />
            </motion.div>
            <div className='bg-darkGreyPrimary w-full'>
                <motion.div 
                    ref={reliabilityRef}
                    initial="hidden"
                    animate={reliabilityInView ? "visible" : "hidden"}
                    variants={slideUp}
                    className="w-full px-4 sm:px-6 md:px-8"
                >
                    <ReliabilityAndroidSteps androidData={androidData}/>
                </motion.div>
                <motion.div 
                    ref={ideaProjectRef}
                    initial="hidden"
                    animate={ideaProjectInView ? "visible" : "hidden"}
                    variants={slideUp}
                    className="w-full px-4 sm:px-6 md:px-8"
                >
                    <AndroidIdeaProject androidData={androidData}/>
                </motion.div>
                <motion.div 
                    ref={featuresRef}
                    initial="hidden"
                    animate={featuresInView ? "visible" : "hidden"}
                    variants={slideUp}
                    className="w-full px-4 sm:px-6 md:px-8"
                >
                    <AndroidFeatures androidData={androidData}/>
                </motion.div>
                <motion.div 
                    ref={conceptBoxRef}
                    initial="hidden"
                    animate={conceptBoxInView ? "visible" : "hidden"}
                    variants={slideUp}
                    className="w-full px-4 sm:px-6 md:px-8"
                >
                    <AndroidConceptBox />
                </motion.div>
                {/* <AndroidProjects /> */}
                <motion.div 
                    ref={projectDisplayRef}
                    initial="hidden"
                    animate={projectDisplayInView ? "visible" : "hidden"}
                    variants={slideUp}
                    className="w-full px-4 sm:px-6 md:px-8"
                >
                    <ProjectDisplay />
                </motion.div>
                <motion.div 
                    ref={faqRef}
                    initial="hidden"
                    animate={faqInView ? "visible" : "hidden"}
                    variants={slideUp}
                    className="w-full px-4 sm:px-6 md:px-8"
                >
                    <AppsFaq />
                </motion.div>
                <motion.div 
                    ref={chooseUsRef}
                    initial="hidden"
                    animate={chooseUsInView ? "visible" : "hidden"}
                    variants={slideUp}
                    className="w-full px-4 sm:px-6 md:px-8"
                >
                    <ChooseUs />
                </motion.div>
                <motion.div variants={fadeIn} className="w-full">
                    <DefaultFooter />
                </motion.div>
            </div>
        </motion.div>
    )
}

export default AndroidPage
